import {ApiError} from '@/api/client'
import {endpoints} from '@/api/endpoints'
import {isRedirecting, setRedirecting} from '@/lib/auth-redirect-flag'
import {
    AUTH_BOUNCE_THRESHOLD,
    incrementBounceCount,
    notifyAuthLoopDetected,
} from '@/lib/auth-bounce-counter'

export function handleUnauthorized(error: Error): void {
    if (!(error instanceof ApiError) || error.status !== 401) {
        return
    }
    if (isRedirecting()) {
        return
    }
    const count = incrementBounceCount()
    if (count > AUTH_BOUNCE_THRESHOLD) {
        notifyAuthLoopDetected()
        return
    }
    setRedirecting(true)
    sessionStorage.setItem('returnTo', window.location.pathname + window.location.search)
    window.location.href = endpoints.auth.keycloakLogin()
}
